import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {selectTenantId} from '../authSlice';

export const useTenantId = () => {
  return useAppSelector(selectTenantId);
};
